import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faEnvelope, faPersonChalkboard, faCircleInfo } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'
import CTAButton from '../../components/CTAButton/CTAButton.js'

import { lP, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, capFirstChar, validateContactFields, validateAddressFields, validateRegistrationExtra } from '../../main.js'

import '../../main.css'
import './Register.css'
import './MRegister.css'

import Cookies from 'universal-cookie'

export default function Register() {

    var [registerPage, setRegisterPage] = useState(1)
    var [formError, setFormError] = useState(false)
    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [formData, setFormData] = useState({
        formVorname: "",
        formNachname: "",
        formMail: "",
        formTel: "",
        formMobil: "",
        formAddressStreet: "",
        formAddressHnr: "",
        formAddressPlace: "",
        formAddressPLZ: "",
        formAddressAddon: "",
        formChannelSelect: 1,
        formBirthdate: "",
        formQualifications: "",
        formChbAGB: 0,
        formChbFotos: 0,
        formChbNewsletter: 0
    })

    useEffect(() => {
        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // no-op
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }
    }, [])

    function postUserdata() {

        var bdate = new Date(formData.formBirthdate)
        var bdateiso = bdate.toISOString()

        document.querySelector("#responseInfo_loading").style.display = "block"
        document.querySelector("#responseInfo_wronginput").style.display = "none"

        var reqbody = {
            "firstname": formData.formVorname,
            "lastname": formData.formNachname,
            "contact": {
                "email": formData.formMail,
                "tel": formData.formTel,
                "mobile": formData.formMobil,
            },
            "address": {
                "nr": formData.formAddressHnr,
                "street": formData.formAddressStreet,
                "addon": formData.formAddressAddon,
                "zipcode": formData.formAddressPLZ,
                "city": formData.formAddressPlace
            },
            "birthday": bdateiso,
            "agreements": {
                "newsletter_agreed": formData.formChbNewsletter ? 1 : 0,
                "photos_agreed": formData.formChbFotos ? 1 : 0,
                "agb_agreed": formData.formChbAGB ? 1 : 0,
            },
            "additionalInfo": {
                "qualifications": formData.formQualifications,
                "preferred_channel": formData.formChannelSelect
            },
            "forEvent": 0
        }

        try {
            fetch(URL_MAINAPI + "/auth/register", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setRegisterPage(4);
                    setResError("");
                } else {
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                }
            })
            )
        } catch (err) {
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }

    function nextRegisterPage(currentpage) {
        let valresult;
        switch (currentpage) {
            case 1:
                valresult = validateContactFields({ email: formData.formMail, tel: formData.formTel, mobile: formData.formMobil });
                if (valresult.error == null && formData.formVorname.trim().length >= 2 && formData.formNachname.trim().length >= 2) {
                    setFormError(false);
                    setRegisterPage(2);
                } else setFormError(true);
                break;
            case 2:
                valresult = validateAddressFields({ nr: formData.formAddressHnr, street: formData.formAddressStreet, addon: formData.formAddressAddon, zipcode: formData.formAddressPLZ, city: formData.formAddressPlace });
                if (valresult.error == null) { setFormError(false); setRegisterPage(3); } else setFormError(true);
                break;
            case 3:
                valresult = validateRegistrationExtra({ newsletter_agreed: formData.formChbNewsletter ? 1 : 0, photos_agreed: formData.formChbFotos ? 1 : 0, agb_agreed: formData.formChbAGB ? 1 : 0, qualifications: formData.formQualifications, preferred_channel: formData.formChannelSelect, birthday: formData.formBirthdate });
                if (valresult.error == null) { setFormError(false); postUserdata() } else setFormError(true);
                break;
            default: setRegisterPage(1);
        }
    }

    if (loggedin) {
        return (
            <div className='mainCon page' id='mainCon'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Registrieren</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card register-card register-info-card'>
                                <h3><FontAwesomeIcon icon={faCircleInfo} /> Du bist bereits angemeldet</h3>
                                <p>Du hast schon ein Helferzeit-Konto und bist eingeloggt. Wenn du ein weiteres Konto für eine andere Person anlegen möchtest, melde dich bitte zuerst ab.</p>
                                <div className='register-info-actions'>
                                    <CTAButton variant="primary" hideArrow={false} title={"Zum Profil"} onclick={() => lP('/profil')} />
                                    <CTAButton variant="secondary" hideArrow={true} title={"Abmelden und neu registrieren"} onclick={() => {
                                        const userCookies = Object.keys(cookies.getAll());
                                        userCookies.forEach((key) => cookies.remove(key));
                                        window.location.href = "/register";
                                    }} />
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </main>
                <MainFooter useEventStyle={false} />
            </div>
        )
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Registrieren</title>
                <meta property="og:title" content="Bei Helferzeit registrieren" />
                <meta property="og:description" content="Erstelle dein Helferzeit-Konto – ganz ohne Event-Anmeldung." />
            </Helmet>

            <main className='page-body'>
                <section className='container section' style={{ paddingTop: '40px' }}>

                    <div className='register-head'>
                        <div className='section-eyebrow'>Helferzeit-Konto</div>
                        <motion.h1
                            variants={boxvar4}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, margin: "-50px" }}
                            className='section-title'
                        >
                            Jetzt registrieren
                        </motion.h1>
                        <p className='section-sub'>Erstelle dein Konto – ganz ohne Event-Anmeldung. So bist du für künftige Veranstaltungen schnell angemeldet.</p>
                    </div>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card register-card'>

                            {(registerPage == 1) ?
                                //PAGE 1
                                < div className='register_squircle_cont'>
                                    <div className='register_squircle_first_cont'>
                                        <h3>Hey, wer bist du?</h3>

                                        <form>
                                            <div className='inputdiv_line'>
                                                <div className="field tip-parent">
                                                    <b>Dein Vorname</b>
                                                    <input type="text" className="in_vorname" name="vorname" placeholder="Vorname" autoFocus maxLength="30" minLength="2" value={formData.formVorname} autoComplete='given-name' onInput={(e) => setFormData({ ...formData, formVorname: capFirstChar(e.target.value) })}></input>
                                                </div>
                                                <div className="field tip-parent">
                                                    <b>Dein Nachname</b>
                                                    <input type="text" className="in_nachname" name="nachname" placeholder="Nachname" maxLength="30" minLength="2" value={formData.formNachname} autoComplete='family-name' onInput={(e) => setFormData({ ...formData, formNachname: capFirstChar(e.target.value) })}></input>
                                                </div>
                                            </div>
                                            <div className="field tip-parent">
                                                <b>Deine E-Mailadresse</b>
                                                <input type="email" className="in_mail" name="mail" placeholder="E-Mail" value={formData.formMail} autoComplete='on' onInput={(e) => setFormData({ ...formData, formMail: e.target.value })}></input>
                                            </div>
                                            <div className="field tip-parent">
                                                <b>Deine Telefonnummer</b>
                                                <input type="tel" className="in_tel" name="tel" placeholder="Telefonnummer (+49 1..)" value={formData.formTel} autoComplete='on' onInput={(e) => setFormData({ ...formData, formTel: e.target.value })}></input>
                                            </div>
                                            <div className="field tip-parent">
                                                <b>Deine Handynummer</b>
                                                <input type="tel" className="in_mobil" name="mobil" placeholder="Mobilnummer (optional)" value={formData.formMobil} autoComplete='on' onInput={(e) => setFormData({ ...formData, formMobil: e.target.value })}></input>
                                            </div>
                                            <br />
                                            {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}

                                            <br /><br />
                                            <CTAButton variant="primary" hideArrow={false} title={"Weiter"} onclick={() => nextRegisterPage(1)}></CTAButton>
                                            <br /><br /><br />
                                            <a className="action_third_a" href={'/'}>Abbrechen</a>
                                        </form>
                                    </div>
                                    <div className='register_squircle_scnd_cont'>
                                        <FontAwesomeIcon className='register_squircle_icon' icon={faAddressCard} />
                                        <p className='register_squircle_explanation'>
                                            Wir benötigen deine E-Mailadresse, damit du dich später wieder anmelden
                                            kannst und wir dir alle wichtigen Infos zukommen lassen können.<br />
                                            Für Fragen und kurzfristige Änderungen, kontaktieren dich Veranstalter ggf. per Handy.
                                        </p>
                                    </div>
                                </div> : (registerPage == 2) ?
                                    // PAGE 2
                                    <div className='register_squircle_cont'>
                                        <div className='register_squircle_first_cont'>
                                            <h3>Wohin können wir dir Post schicken, {formData.formVorname}?</h3>

                                            <form>
                                                <div className='inputdiv_line'>
                                                    <div className="field tip-parent">
                                                        <b>Straße</b>
                                                        <input type="text" className="in_street" name="street" placeholder="Straße" autoFocus value={formData.formAddressStreet} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressStreet: e.target.value })}></input>
                                                    </div>
                                                    <div className="field field_short tip-parent">
                                                        <b>Haus-Nr.</b>
                                                        <input type="text" className="in_hnr" name="hnr" placeholder="Nr." value={formData.formAddressHnr} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressHnr: e.target.value })}></input>
                                                    </div>
                                                </div>
                                                <div className='inputdiv_line'>
                                                    <div className="field field_short tip-parent">
                                                        <b>Postleitzahl</b>
                                                        <input type="text" className="in_plz" name="plz" placeholder="PLZ" value={formData.formAddressPLZ} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressPLZ: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <b>Wohnort</b>
                                                        <input type="text" className="in_place" name="place" placeholder="Ort" value={formData.formAddressPlace} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressPlace: e.target.value })}></input>
                                                    </div>
                                                </div>
                                                <div className="field tip-parent">
                                                    <b>Adresszusatz</b>
                                                    <input type="text" className="in_addraddon" name="addraddon" placeholder="Adresszusatz (optional)" value={formData.formAddressAddon} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressAddon: e.target.value })}></input>
                                                </div>
                                                <br />
                                                {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}

                                                <br /><br />
                                                <CTAButton variant="primary" hideArrow={true} title={"Zurück"} onclick={() => setRegisterPage(1)}></CTAButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                <CTAButton variant="primary" hideArrow={false} title={"Weiter"} onclick={() => nextRegisterPage(2)}></CTAButton>
                                            </form>
                                        </div>
                                        <div className='register_squircle_scnd_cont'>
                                            <FontAwesomeIcon className='register_squircle_icon' icon={faEnvelope} />
                                            <p className='register_squircle_explanation'>
                                                Wir senden dir alle wichtigen Infos per E-Mail. Auf Wunsch senden dir manche Veranstalter zusätzlich Infos per Post.

                                            </p>
                                            <div className="field field_dyn tip-parent">
                                                <select className="in_channel" name="channel" value={formData.formChannelSelect} placeholder="Informationskanal" required onChange={(e) => setFormData({ ...formData, formChannelSelect: e.target.value })}>
                                                    <optgroup label="Wähle den Kanal">
                                                        <option selected value="1">E-Mail</option>
                                                        <option value="2">E-Mail & Post</option>
                                                    </optgroup>
                                                </select>
                                            </div>
                                        </div>
                                    </div> : (registerPage == 3) ?
                                        // PAGE 3
                                        <div className='register_squircle_cont'>
                                            <div className='register_squircle_first_cont'>
                                                <h3>Wir brauchen noch ein paar Infos</h3>

                                                <form>
                                                    <div className="field tip-parent">
                                                        <b>Dein Geburtsdatum</b>
                                                        <input type="date" className="in_birthdate" name="birthdate" placeholder="Geburtsdatum" autoFocus value={formData.formBirthdate} autoComplete='on' onInput={(e) => setFormData({ ...formData, formBirthdate: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <b>Zusatzqualifikationen</b>
                                                        <input type="text" className="in_qualifications" name="qualifications" placeholder="Qualifikationen (optional)" value={formData.formQualifications} autoComplete='off' onInput={(e) => setFormData({ ...formData, formQualifications: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="agb_accepted" value="1" checked={formData.formChbAGB} onChange={(e) => setFormData({ ...formData, formChbAGB: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div className='noselect'>Ich stimme den <a href="https://www.helferzeit.de/rechtliches" target="_blank">AGB und Datenschutzbestimmungen</a> zu</div>
                                                        </label>
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="fotos_accepted" value="1" checked={formData.formChbFotos} onChange={(e) => setFormData({ ...formData, formChbFotos: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div className='noselect'>Ich stimme dem Erstellen und Veröffentlichen von Fotoaufnahmen im Rahmen aller angemeldeten Events zu (Optional)</div>
                                                        </label>
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="newsletter_accepted" id="newsletter_allowed" value="1" checked={formData.formChbNewsletter} onChange={(e) => setFormData({ ...formData, formChbNewsletter: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div id="newsletter_accepted_text" className='noselect'>Ich möchte Newsletter und Updates erhalten.<br />(Optional; Benachrichtigungen erhältst du immer)</div>
                                                        </label>
                                                    </div>
                                                    <br />
                                                    {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}
                                                    <p className="responseInfo" id="responseInfo_loading">
                                                        Lädt... Bitte warten...
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_wronginput">
                                                        Bitte überprüfe deine Eingaben!<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_servererror">
                                                        Es gab einen Fehler bei der Verarbeitung.<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <br /><br />
                                                    <CTAButton variant="primary" hideArrow={true} title={"Zurück"} onclick={() => setRegisterPage(2)}></CTAButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                    <CTAButton variant="primary" hideArrow={false} title={"Speichern"} onclick={() => nextRegisterPage(3)}></CTAButton>
                                                </form>
                                            </div>
                                            <div className='register_squircle_scnd_cont'>
                                                <FontAwesomeIcon className='register_squircle_icon' icon={faPersonChalkboard} />
                                                <p className='register_squircle_explanation'>
                                                    Beschreibe hier nur Qualifikationen, die für uns relevant sein könnten.
                                                    Beispiele hierfür sind:<br />
                                                    <i>B-Führerschein, NotSan, Betrieblicher Ersthelfer</i><br /><br />
                                                    Angaben bitte in Stichpunkten und durch Komma getrennt
                                                </p>
                                            </div>
                                        </div> :
                                        // PAGE 4 – Thanks
                                        < div className='register_squircle_cont'>
                                            <div className='register_squircle_first_cont'>
                                                <h3>{(formData.formVorname == "") ? 'Bitte bestätige deine E-Mailadresse!' : 'Hey ' + formData.formVorname + ', bitte bestätige deine E-Mailadresse!'}</h3>

                                                <p>
                                                    Um die Registrierung abzuschließen musst du deine E-Mailadresse bestätigen. Hierfür erhältst du in den nächsten Minuten per Mail einen Bestätigungslink.<br />
                                                    Danach kannst du dich jederzeit anmelden und dich zu öffentlichen Veranstaltungen anmelden.<br />
                                                    Falls du keine Mail erhalten hast, <b>prüfe bitte den Spam-Ordner</b> deines E-Mailpostfachs oder kontaktiere uns <a href="https://www.helferzeit.de/support">hierüber</a>.
                                                </p>
                                                <br />
                                                <div className='register-info-actions'>
                                                    <CTAButton variant="primary" hideArrow={false} title={"Zum Login"} onclick={() => lP('/login')} />
                                                    <CTAButton variant="secondary" hideArrow={true} title={"Zur Startseite"} onclick={() => lP('/')} />
                                                </div>
                                            </div>

                                            <br />
                                        </div>
                            }

                            <br />
                        </div>
                    </motion.div>
                </section>
            </main>

            < MainFooter useEventStyle={false} />
        </div >
    )
}
